import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { useTranslation } from 'react-i18next';
import ProductGroupMaster from './ProductGroupMaster';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';

export const Context = React.createContext();
function ContextWrapper({ OpenReArrangeFunction, state, setState }) {
  const { t } = useTranslation('common');

  const {
    SystemMastersDetails: { productGroupList },
    Users: { logInRights },
  } = useSelector((reducer) => reducer);
  const { CheckActionPermission } = useComponent();

  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'productGroups', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'productGroups', 'delete');
  const [cards, setCards] = useState([]);
  const [formState, setFormState] = useState({
    values: {},
    errors: {},
    isSubmitted: false,
    disableBtn: false,
    isLoading: false,
  });

  const validateInput = useCallback(
    (moduleName, id) => {
      if (moduleName.length === 0) {
        setFormState((prev) => ({ ...prev, errors: { ...prev.errors, [id]: t('CARD_ITEMS.PRODUCT_GROUP_REQUIRED') } }));
        return;
      }
      const doesExist = cards.find((obj) => obj.name === moduleName && obj._id !== id);
      if (doesExist) {
        setFormState((prev) => ({ ...prev, errors: { ...prev.errors, [id]: t('CARD_ITEMS.THIS_ENTRY_ALREADY_EXITS') } }));
      } else {
        setFormState((prev) => {
          return { ...prev, errors: {} };
        });
      }
    },
    [cards],
  );

  const updateSubmitState = useCallback((val) => {
    setFormState((prev) => ({ ...prev, isSubmitted: val, values: {}, errors: {} }));
  }, []);

  const setFormValues = useCallback(
    (val, id) => {
      setFormState((prev) => ({ ...prev, values: { ...prev.values, [id]: val } }));
      validateInput(val, id);
    },
    [validateInput],
  );

  useEffect(() => {
    setCards(productGroupList);
    if (state?.rearrangeModal === 'ProductGroup') {
      setState((prev) => ({
        ...prev,
        rearrangeData: [...productGroupList],
      }));
    }
  }, [productGroupList, state?.rearrangeModal]);

  const updateArray = useCallback((val, _id) => {
    if (_id) {
      setCards((prev) => prev.map((obj) => (obj._id === _id ? { ...obj, ...val } : obj)));
      return null;
    }
    setCards((prev) => [...prev, { _id, ...val }]);
  }, []);

  const addNewItem = useCallback(() => {
    setCards((prev) => [...prev, { _id: `_id${prev.length}`, name: '' }]);
  }, []);

  const removeFromArray = useCallback((_id) => {
    setCards((prev) => prev.filter((obj) => obj._id !== _id));
    setFormState({
      values: {},
      errors: {},
      isSubmitted: false,
      disableBtn: false,
      isLoading: false,
    });
  }, []);

  const value = useMemo(
    () => ({
      cards,
      updateArray,
      addNewItem,
      removeFromArray,
      updateSubmitState,
      formState,
      setFormValues,
      MasterAddEditAccess,
      MasterDeleteAccess,
      OpenReArrangeFunction,
      setFormState,
    }),
    [cards, updateArray, addNewItem, removeFromArray, updateSubmitState, formState, setFormValues, MasterAddEditAccess, MasterDeleteAccess, setFormState],
  );

  return (
    <Context.Provider value={value}>
      <ProductGroupMaster />
    </Context.Provider>
  );
}

export default ContextWrapper;
